import {SegmentedControl} from '@primer/react'
import {useMemo} from 'react'

import {pluralizeCategory} from './helpers/pluralize-category'

export const ALL_CATEGORIES_SENTINEL = '__all__'

interface CategoryFilterProps {
  /** Available categories (excluding the "All" sentinel). */
  categories: string[]
  /** Current selection (`ALL_CATEGORIES_SENTINEL` for All). */
  value: string
  onChange: (next: string) => void
  /** Aria label for the segmented control. */
  ariaLabel?: string
}

export function CategoryFilter({
  categories,
  value,
  onChange,
  ariaLabel = 'Filter actors by category',
}: CategoryFilterProps) {
  const segments = useMemo(() => [ALL_CATEGORIES_SENTINEL, ...categories], [categories])

  return (
    <SegmentedControl aria-label={ariaLabel} size="small">
      {segments.map(segment => (
        <SegmentedControl.Button key={segment} selected={segment === value} onClick={() => onChange(segment)}>
          {segment === ALL_CATEGORIES_SENTINEL ? 'All' : pluralizeCategory(segment)}
        </SegmentedControl.Button>
      ))}
    </SegmentedControl>
  )
}
